import React from 'react'
import PeriodFilterBlock from './PeriodFilterBlock'
import Loader from './Loader'
import LineChart from './LineChart'

const LineChartBlock = ({ periodFilters, isLoading, state }) => {
  return (
    <div className='currency-chart__line-chart-block'>
      <div className='currency-chart__period-filters'>
        <p className='currency-chart__period-filters-text'>Период:</p>
        {periodFilters.map((item, index) => {
          return <div className='currency-chart__period-filter-item' key={index}>
            <PeriodFilterBlock {...{ ...item, periodFilters }} />
          </div>
        })}
      </div>
      <>
        {isLoading && <Loader />}
        {!isLoading && state.chartData && state.todayData &&
          <LineChart chartData={state.chartData} todayData={state.todayData} />}
      </>
    </div>
  )
}

export default LineChartBlock
